import React, { ReactElement, forwardRef, useImperativeHandle } from 'react';
import { KView, KText, PageContext, KScrollView } from '@/component/RtlLayout';
import { TouchableWithoutFeedback } from 'react-native';
import { convertStyles } from '@kibt/krn-utils';
import { $k18n } from '@/common/i18n';
import { CountryNameList, currentCountry } from '@/common/const';

import SrcStyles from './index.styl';
const Styles = convertStyles(SrcStyles);

import MyImage from '../MyImage';
import AddNewAddressIconPng from '@/assets/icon_detail/add_new_address_icon.png';
import { useDraggableHeight } from '@/hooks/useDraggableHeight';
import { isIOS, isMobileDeviceValue, isWeb, PCMaxWidth, screenHeight } from '@/common/device-info';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';

type IProps = {
    handleChooseNewAddress: any;
    addressList: any;
    handleAddAddress: any;
};

const isIdn = CountryNameList.IDN.includes(currentCountry);
const isBra = CountryNameList.BRA.includes(currentCountry);

const ChooseAddress = forwardRef(function specLine(props: IProps, ref): ReactElement {
    const { addressList, handleChooseNewAddress, handleAddAddress } = props;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useImperativeHandle(
        ref,
        () => {
            return {
                // 暴露出去的方法,
            };
        },
        []
    );
    const getName = address => {
        if (isIdn) {
            return `${address.fullName || ''}`;
        } else if (isBra) {
            return `${address.firstName || ''} ${address.lastName || ''}`;
        }
        return '';
    };

    return addressList && addressList.length ? (
        <PageContext.Provider value={{ Styles }}>
            <KView
                rtlClassName={'address-popup'}
                style={{
                    height: '75vh',
                    width: isMobileDeviceValue ? '100%' : PCMaxWidth,
                    overflowX: 'scroll',
                }}>
                <KView rtlClassName={'title'}>
                    <KText rtlClassName={'title-text'}>{$k18n('选择收货地址')}</KText>
                </KView>
                <KScrollView rtlClassName={'scroll-view-container'} showsVerticalScrollIndicator={false}>
                    <KView rtlClassName={'container'}>
                        <KTouchableWithoutFeedback onPress={() => handleAddAddress()}>
                            <KView
                                rtlClassName={'add-address'}
                                style={{"borderBottomWidth":1,"borderBottomColor":"rgba(0, 0, 0, 0.1)","marginBottom":"2.8985507246376816rem"}}>
                                <KView rtlClassName={'add-address-title'}>
                                    <KText rtlClassName={'add-address-title-text'}>{$k18n('增加新地址')}</KText>
                                </KView>
                                <KView
                                    rtlClassName={'add-address-icon'}
                                    style={{"cursor":"pointer"}}>
                                    <MyImage imageSrc={AddNewAddressIconPng} styleObj={{ width: 28, height: 28 }} />
                                </KView>
                            </KView>
                        </KTouchableWithoutFeedback>

                        <KView rtlClassName={'address-wrapper-container'}>
                            <KView rtlClassName={'address-wrapper'}>
                                {addressList
                                    ? addressList.map((address, index) => {
                                          return (
                                              <KTouchableWithoutFeedback onPress={() => handleChooseNewAddress(address, index)}>
                                                  <KView
                                                      rtlClassName={'content'}
                                                      style={{
                                                          borderBottomWidth: 1,
                                                          borderBottomColor: 'rgba(0, 0, 0, 0.1)',
                                                          cursor: 'pointer',
                                                          width: isMobileDeviceValue ? '100%' : '90rem',
                                                      }}>
                                                      <KView
                                                          style={{
                                                              width: isMobileDeviceValue ? '100%' : '90rem',
                                                          }}
                                                          rtlClassName={'middle-area'}>
                                                          <KView rtlClassName={'middle-area-title'}>
                                                              <KView
                                                                  rtlClassName={'name'}
                                                                  style={{"flex":1}}>
                                                                  <KText rtlClassName={['name-text', address.chargeErr ? 'unavailable-text' : '']}>
                                                                      {getName(address)}
                                                                  </KText>
                                                              </KView>

                                                              <KView
                                                                  rtlClassName={'tag'}
                                                                  style={{"marginLeft":"0.9661835748792271rem"}}>
                                                                  {address.status === 1 ? (
                                                                      <KText rtlClassName={'is-default'}>{$k18n('默认地址')}</KText>
                                                                  ) : null}
                                                                  {address.chargeErr ? (
                                                                      <KText rtlClassName={'unavailable'}>{$k18n('暂不支持')}</KText>
                                                                  ) : null}
                                                              </KView>
                                                          </KView>

                                                          <KView
                                                              style={{
                                                                  width: isMobileDeviceValue ? '100%' : '90rem',
                                                              }}
                                                              rtlClassName={'middle-area-line'}>
                                                              <KText
                                                                  rtlClassName={[address.chargeErr ? 'unavailable-text' : 'middle-area-line-text']}>
                                                                  {`${$k18n({
                                                                      id: 'k_332957',
                                                                      text: '手机号',
                                                                  })}:${address.phone}`}
                                                              </KText>
                                                          </KView>

                                                          {address.email ? (
                                                              <KView
                                                                  style={{
                                                                      width: isMobileDeviceValue ? '100%' : '90rem',
                                                                  }}
                                                                  rtlClassName={'middle-area-line'}>
                                                                  <KText
                                                                      rtlClassName={[
                                                                          address.chargeErr ? 'unavailable-text' : 'middle-area-line-text',
                                                                      ]}>
                                                                      {`${$k18n({ id: 'k_249051', text: '邮箱' })}:${address.email}`}
                                                                  </KText>
                                                              </KView>
                                                          ) : null}

                                                          <KView
                                                              style={{
                                                                  width: isMobileDeviceValue ? '100%' : '90rem',
                                                              }}
                                                              rtlClassName={'middle-area-line'}>
                                                              <KText
                                                                  rtlClassName={[address.chargeErr ? 'unavailable-text' : 'middle-area-line-text']}>
                                                                  {address.streetName || ''}&nbsp;
                                                                  {address.streetNumber || ''}
                                                                  {address.complement || ''}
                                                              </KText>
                                                          </KView>

                                                          <KView
                                                              style={{
                                                                  width: isMobileDeviceValue ? '100%' : '90rem',
                                                              }}
                                                              rtlClassName={'middle-area-line'}>
                                                              <KText
                                                                  rtlClassName={[address.chargeErr ? 'unavailable-text' : 'middle-area-line-text']}>
                                                                  {address.provinceName || ''}&nbsp;
                                                                  {address.cityName}&nbsp;
                                                                  {address.districtName || ''}&nbsp;
                                                              </KText>
                                                          </KView>

                                                          {address.postalCode ? (
                                                              <KView
                                                                  style={{
                                                                      width: isMobileDeviceValue ? '100%' : '90rem',
                                                                  }}
                                                                  rtlClassName={'middle-area-line'}>
                                                                  <KText
                                                                      rtlClassName={[
                                                                          address.chargeErr ? 'unavailable-text' : 'middle-area-line-text',
                                                                      ]}>{`${$k18n('邮编')}:${address.postalCode}`}</KText>
                                                              </KView>
                                                          ) : null}

                                                          {address.cpf ? (
                                                              <KView
                                                                  style={{
                                                                      width: isMobileDeviceValue ? '100%' : '90rem',
                                                                  }}
                                                                  rtlClassName={'middle-area-line'}>
                                                                  <KText
                                                                      rtlClassName={[
                                                                          address.chargeErr ? 'unavailable-text' : 'middle-area-line-text',
                                                                      ]}>
                                                                      {address.cpf}
                                                                  </KText>
                                                              </KView>
                                                          ) : null}
                                                      </KView>
                                                  </KView>
                                              </KTouchableWithoutFeedback>
                                          );
                                      })
                                    : null}
                            </KView>
                        </KView>
                    </KView>
                </KScrollView>
            </KView>
        </PageContext.Provider>
    ) : null;
});
export default ChooseAddress;
